var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.withLogin != null)?_c('Login',{staticClass:"absolute top-0 right-0 mr-8"}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }